import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { isEqual } from 'lodash'
import { memo, useState } from 'react'
import dayjs from 'dayjs'
import PrimeTable from '../../../components/PrimeTable'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import { useModal } from '../../../components/Utils/UseModal'
import ModalConfirmaPagamento from './ModalConfirmaPagamento'

const retornaLocalAtendimento = (u = []) => ({
  idPagamento: u?.[0] || undefined,
  dsVendedor: u?.[1]?.[1] || undefined,
  dtInclusao: u?.[2] ? dayjs(u?.[2]).format('DD/MM/YYYY HH:mm') : null,
  dtReferenciaInicio: u?.[3] ? dayjs(u?.[3]).format('DD/MM/YYYY') : null,
  dtReferenciaFim: u?.[4] ? dayjs(u?.[4]).format('DD/MM/YYYY') : null,
  totalVenda: u?.[5] || undefined,
  totalComissao: u?.[6] || undefined,
  pagoPor: u?.[7]?.[1] || undefined,
  dataPago: u?.[8] ? dayjs(u?.[8]).format('DD/MM/YYYY HH:mm') : null,
  totalPago: u?.[9] || undefined,
})
const Edicao = ({ dados, voltar }) => {
  const openModal = useModal(ModalConfirmaPagamento)
  const [refresh, setRefresh] = useState(false)

  const abreConfirmaPagamento = async () => {
    await openModal({
      dsVendedor: dados[1][1],
      idPagamento: dados[0],
      totalComissao: dados[6],
    })

    setRefresh((v) => !v)
  }

  return (
    <Formik initialValues={retornaLocalAtendimento(dados)}>
      {({ isSubmitting }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dsVendedor"
                label="Vendedor"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dtInclusao"
                label="Data de Inclusão"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dtReferenciaInicio"
                label="Referência Inicial"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dtReferenciaFim"
                label="Referência Final"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="pagoPor"
                label="Pago Por"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <Field
                InputLabelProps={{ shrink: true }}
                component={TextField}
                name="dataPago"
                label="Data de Pagamento"
                fullWidth
                disabled
                margin="dense"
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CurrencyField
                fullWidth
                value={dados?.[9]}
                variant="outlined"
                margin="dense"
                label="Total Pago"
                disabled
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CurrencyField
                fullWidth
                value={dados?.[5]}
                variant="outlined"
                margin="dense"
                label="Total de Vendas"
                disabled
                size="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CurrencyField
                fullWidth
                value={dados?.[6]}
                variant="outlined"
                margin="dense"
                label="Total de Comissão"
                disabled
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              <PrimeTable
                codigo="CtrlPagamentoComissao"
                action="listaItensPagamento"
                rows={50}
                habSearch={false}
                refresh={refresh}
                colStyle={[{}, {}, {}, {}, { textAlign: 'center' }]}
                head={[
                  'Cod Proposta',
                  'Cod Pedido',
                  'Descrição',
                  'Venda',
                  '% Comissão',
                  'R$ Comissão',
                ]}
                line={(item) => [
                  item[2],
                  item[3],
                  item[4],
                  item[5],
                  `${item[6]}%`,
                  item[7],
                ]}
                collumnsCurrency={[3, 5]}
                parametros={{ idPagamento: dados[0] }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              {dados?.[8] === null && (
                <Button
                  onClick={abreConfirmaPagamento}
                  disabled={isSubmitting}
                  variant="contained"
                  color="primary"
                  style={{ margin: '5px' }}
                >
                  Pagar Comissão
                </Button>
              )}

              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
